import { render, staticRenderFns } from "./rules-detail.vue?vue&type=template&id=19d89da3&"
import script from "./rules-detail.vue?vue&type=script&lang=js&"
export * from "./rules-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports